/* import __COLOCATED_TEMPLATE__ from './event-part-message-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();